<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("Tax") }} {{ $tc("setting", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $t("Tax") }} {{ $tc("setting", 2) }}
        </div>
      </div>
      <div>
        <router-link v-if="$can('create', 'Charge Settings')" variant="default" class="btn-blue" to="add-tax-setting">{{
          $tc("add") }}</router-link>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input @input="onSearch" v-model="searchValue" placeholder="Search..."></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown :onSelect="(filterIsActive) => {
          getCinemaChargesList(selectedid, filterIsActive);
        }
          " />
        <div  class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item v-for="(list, listIndex) in viewingnumbers" :key="listIndex"
              @click="onDropDownChangeValue(list.name)">{{ list.name }}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <div class="white-wrapper mt-2">
      <div class="row">
        <div class="col-lg-3 col-xl-3">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema ? 'shift-up' : ''">{{ $t("select") }} {{ $tc("cinema", 1)
              }}</label>
            <b-dropdown :disabled="isRoleID" :text="selectedCinema" variant="dropdown-curve" class="w-100">
              <div class="px-2 pb-2">
                <input required autofocus type="search" placeholder="Search Cinema" class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema($event.target.value)" v-on:keydown="onSearchCinema($event.target.value)"
                  v-on:search="onSearchCinema($event.target.value)" v-model="searchCinema" />
              </div>
              <b-dropdown-item v-for="(dropdownItem, dropdownIndex) in cinemaList" :key="dropdownIndex" href="#"
                @click="onDropdownChange($event, dropdownItem)">{{ dropdownItem.cine_name }}</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>

        <div v-if="selectedCinema != ''" class="col-lg-5">
          <div class="dropdown-curve-container">
            <multiselect v-model="cinemaArray" :multiple="true" :options="cinemaList" :searchable="true"
              label="cine_name" track-by="cine_name" placeholder="Select Cinemas for adding settings"></multiselect>
          </div>
        </div>

        <div class="col-lg-4 aling-self-center">
          <div class="row">
            <div class="col-6 aling-self-center" v-if="cinemaArray && cinemaArray.length > 0">
              <button v-if="showRadio == false" @click="showRadio = true" class="btn-blue w-100">
                Add Single
              </button>
              <button v-else @click="duplicateCharges('Single')" class="btn-blue w-100">
                Done
              </button>
            </div>

            <div class="col-6 aling-self-center" v-if="cinemaArray && cinemaArray.length">
              <button @click="OpenModal" class="btn-blue w-100">Add All</button>
            </div>
          </div>
        </div>
      </div>

      <!-- LIST VIEW -->
      <table class="list-view-table shadow-none mt-2" v-if="listView">
        <thead>
          <tr>
            <th class="text-left" style="width: 10%">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>{{ $tc("setting", 2) }} {{ $t("name") }}</th>
            <th v-if="showRadio && cinemaArray && cinemaArray.length > 0">
              &nbsp;
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cinemaCharge, cinemaChargeIndex) in cinemaChargesList" :key="cinemaChargeIndex">
            <td class="text-center" v-if="showRadio && cinemaArray && cinemaArray.length > 0">
              <b-form-checkbox class="j-checkbox" :value="cinemaCharge" v-model="selected_charges" />
            </td>

            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot :status="cinemaCharge.pas_is_active === 'Y' ? 'active' : 'inactive'
                  " />
                <span v-if="$can('update', 'Charge Settings')" class="edit-icon ml-4 blue-icon" @click="
                  goToRoute('/cinema-manager/edit-tax-setting', cinemaCharge)
                  " style="cursor: pointer" v-b-tooltip="'Edit'" tabindex="0">
                  <i class="edit-pen icon blue-icon"></i>
                </span>
                <span class="view-icon ml-2 blue-icon" @click="
                  goToRoute('/cinema-manager/view-tax-setting', cinemaCharge)
                  " style="cursor: pointer" v-b-tooltip="'View'" tabindex="0">
                  <i class="icon-eye icon blue-icon"></i>
                </span>
              </div>
            </td>

            <td>{{ cinemaCharge.pas_charge_setting_name }}</td>
          </tr>
          <tr v-if="cinemaChargesList.length == 0">
            <td :colspan="showRadio && cinemaArray && cinemaArray.length > 0 ? 3 : 2
              ">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal id="confirmation" title="Confirm" hide-footer no-close-on-backdrop>
      <label class="h4 mt-2 mb-4 text-center">Are you sure you want to add all charge settings?</label>

      <br />
      <div class="text-center">
        <button class="btn-blue" @click.prevent.stop="duplicateCharges('All')">
          Yes
        </button>
        <button class="btn-blue text-right" @click.prevent.stop="hideModal('confirmation')">
          No
        </button>
      </div>
    </b-modal>

    <b-pagination v-model="currentPage" :total-rows="rows" @change="onChangePagination($event)" :per-page="perPage"
      aria-controls="my-table"></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      isRoleID: true,
      isRoleID1: null,
      getitem: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedid: "",
      debounce: null,
      searchValue: "",
      searchKey: "pas_charge_setting_name", //the key name in your table
      cinemaList: [],
      selectedCinema: "",
      cinemaChargesList: [],
      gridView: false,
      listView: true,
      cinemaArray: [],
      showRadio: false,
      selected_charges: [],
      cinemaListCopy: [],
      searchCinema: "",
      obj: null,
    };
  },
  computed: {
    viewingRange() {

          if (this.perPage === "all") {
          return `Viewing All ${this.rows}`;
        }
        
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    console.log(this.secureStore.get(""))
    this.obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.isRoleID1 = roleid;
    if (true) {
      this.isRoleID = false;
    }
    // this.getCinemaChargesList();
    this.getCinemaList(this.obj);
    this.getviewingnumber();
  },
  mounted() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema = CinemaObj.cine_name;
      this.getCinemaChargesList(CinemaObj.cine_id);
    }
  },
  methods: {
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.cinemaList = this.cinemaListCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.cinemaList = this.cinemaListCopy;
      }
    },
    OpenModal: function () {
      this.$bvModal.show("confirmation");
    },
    hideModal: function (modal) {
      if (modal == "confirmation") {
        this.$bvModal.hide("confirmation");
      }
    },
    duplicateCharges: function (flag) {
      let dupFlag = true;
      this.cinemaArray.map((x) => {
        if (x.cine_id == this.selectedid) {
          dupFlag = false;
        }
      });
      if (dupFlag == true) {
        let payload = {
          cinemaArray: this.cinemaArray,
          selected_charges:
            this.selected_charges.length > 0 ? this.selected_charges : null,
          cinema_id: this.selectedid,
        };

        CinemasService.DuplicateChargeSettings(payload)
          .then(async (response) => {
            const { data } = response;
            if (data && data.status) {
              this.cinemaArray = [];
              this.showRadio = false;
              this.selected_charges = [];
              this.selectedCinema = "";
              (this.selectedid = ""), this.hideModal("confirmation");
              this.$toasted.show(data.message);
              this.getCinemaList(this.obj);
            } else {
              // Show Error Message
              this.$toasted.show(data.message);
              console.log("data.message :", data.message);
              this.hideModal("confirmation");
              this.selected_charges = [];
              // this.$toasted.show(data.err);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("Catch Error On duplicate charges :", error);
          });
      } else {
        this.$toasted.show("Cant apply charges to the same cinema");
        this.hideModal("confirmation");
        this.cinemaArray = [];
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = 'all';
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCinemaChargesList(this.selectedid);
      } else if (this.isRoleID1 != 1) {
        this.currentPage = event;
        this.getCinemaChargesList(this.getitem);
      } else {
        this.currentPage = event;
        this.getCinemaChargesList(this.selectedid);
      }
    },

    //search
    onSearch(event) {
      this.searchValue = "";
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.searchValue = event;
        this.getCinemaChargesList(this.selectedid);
      }, 1500);
    },

    // Saif
    getCinemaList: function (cine_id) {
      let payload = null;
      cine_id == null
        ? (payload = { tableName: "ms_cinemas", cine_is_active: "Y" })
        : (payload = {
          tableName: "ms_cinemas",
          cine_is_active: "Y",
          cine_id: cine_id,
        });
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            console.log("data :", data);

            this.cinemaList = data.Records;
            this.cinemaListCopy = data.Records;

            this.cinemaList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                // this.getitem = x.cine_id;
                this.onDropdownChange(null, {
                  cine_id: x.cine_id,
                  cine_name: x.cine_name,
                });
                // this.getCinemaChargesList(this.getitem);
              }
            });
          } else {
            //  Show Error Message
            this.$toasted.show(data.message);
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error On getCinemaList :", error);
        });
    },
    getCinemaChargesList: function (id, filterIsActive = "Y") {
      this.cinemaChargesList = [];
      let body = {
        // limit: this.perPage,
        limit: this.selectedvalue === "All" ? "all" : this.perPage,
        currentPage: this.currentPage,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        filter_is_active: filterIsActive,
      };
      console.log("body :", body, id);
      CinemasService.GetCinemaChargesListByCinemaId(id, body)
        .then(async (response) => {
          const { data } = response;
          console.log("charges data :", data);
          if (data && data.status && data.Records.length > 0) {
            this.cinemaChargesList = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            // Show Error Message
            this.rows = 0; 
        this.selectedvalue = "10";
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("Catch Error On GetCinemaCharges :", error);
        });
    },
    goToRoute: function (path, { cinema_id, pas_id, pas_charge_setting_name }) {
      this.$router.push({
        path: path,
        query: {
          id: cinema_id,
          pas_id,
          pas_charge_setting_name,
        },
      });
    },
    onDropdownChange: function (event, item) {
      this.selectedCinema = item.cine_name;
      this.selectedid = item.cine_id;
      this.getCinemaChargesList(item.cine_id);
      this.searchCinema = "";
      this.onSearchCinema(null);
      this.$store.dispatch("selectDropdownCinema", item);
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ChargeSettingComponents/chargeSetting.vue